import axios from 'axios';
import { API_BASE_URL } from '@config';
import { showMessage } from 'app/store/actions/fuse';
import * as ActionsDialog from 'app/store/actions';

export const SET_JOB_LIST = 'SET_JOB_LIST';
export const setJobList = jobs => {
	return {
		type: SET_JOB_LIST,
		payload: jobs
	};
};

export const SET_JOB_ERROR = 'SET_JOB_ERROR';
export const setJobError = jobs => {
	return {
		type: SET_JOB_ERROR,
		payload: jobs
	};
};

export const SET_SEARCH_TEXT = 'SET_SEARCH_TEXT';
export const setSearchText = event => {
	return {
		type: SET_SEARCH_TEXT,
		searchText: event.target.value
	};
};

// SUCCESS
export const SET_JOB = 'SET_JOB';
export const setJob = job => ({
	type: SET_JOB,
	payload: job
});

// SELECTED
export const SET_SELECTED = 'SET_SELECTED';
export const setSelected = job => ({
	type: SET_SELECTED,
	payload: job
});

// CLEAR
export const CLEAR_JOB = 'CLEAR_JOB';
export const clearJob = () => ({
	type: CLEAR_JOB
});

export const CLEAR_JOBS_REDUCER = 'CLEAR_JOBS_REDUCER';
export const clearJobsReducer = () => ({
	type: CLEAR_JOBS_REDUCER
});

export const CLEAR_ERROR = 'CLEAR_ERROR';
export const clearError = () => ({
	type: CLEAR_ERROR
});

export const newJob = () => dispatch => {
	const data = {
		data: {
			cores: 1,
			nodes: 1,
			script: '',
			gpus: 0,
			walltime: '01:00:00'
		},
		description: '',
		name: '',
	};
	dispatch(setJob(data));
	return data;
};

export const getJobs = () => dispatch => {
	dispatch(ActionsDialog.toggleLoading());
	const request = axios.get(`${API_BASE_URL}/api/jobs/`);
	return request
		.then(res => {
			dispatch(ActionsDialog.toggleLoading());
			dispatch(setJobList(res.data));
		})
		.catch(err => {
			dispatch(ActionsDialog.toggleLoading());
			dispatch(setJobError({ ...err.data, type: 'modal' }));
		});
};

export const submitJob = (id, cluster, runAsAdmin) => dispatch => {
	dispatch(ActionsDialog.toggleLoading());
	dispatch(showMessage({ message: 'Submitting Job' }));
	const request = axios.post(`${API_BASE_URL}/api/jobs/submit`, { id, cluster, runAsAdmin });
	return request
		.then(() => {
			dispatch(ActionsDialog.toggleLoading());
			dispatch(showMessage({ message: 'Job Submitted' }));
		})
		.catch(err => {
			dispatch(ActionsDialog.toggleLoading());
			dispatch(setJobError({ ...err.data, type: 'modal' }));
		});
};

export const cancelJob = (job, cluster) => dispatch => {
	dispatch(ActionsDialog.toggleLoading());
	const request = axios.post(`${API_BASE_URL}/api/jobs/cancel`, { job, cluster });
	return request
		.then(() => {
			dispatch(ActionsDialog.toggleLoading());
			dispatch(showMessage({ message: 'Job Canceled' }));
		})
		.catch(err => {
			dispatch(ActionsDialog.toggleLoading());
			dispatch(setJobError({ ...err.data, type: 'modal' }));
		});
};

export const saveJob = job => dispatch => {
	const formData = new FormData();
	formData.set('job', JSON.stringify(job));
	dispatch(ActionsDialog.toggleLoading());
	const request = axios.post(`${API_BASE_URL}/api/jobs/`, formData);
	return request
		.then(() => {
			dispatch(ActionsDialog.toggleLoading());
			dispatch(ActionsDialog.closeDialog());
			dispatch(showMessage({ message: 'Job Saved' }));
			dispatch(getJobs());
		})
		.catch(err => {
			dispatch(ActionsDialog.toggleLoading());
			dispatch(setJobError({ ...err.data, type: 'form' }));
		});
};

export const editJob = (job) => dispatch => {
	const formData = new FormData();
	formData.set('job', JSON.stringify(job));
	dispatch(ActionsDialog.toggleLoading());
	const request = axios.put(`${API_BASE_URL}/api/jobs/`, formData);
	return request
		.then(() => {
			dispatch(ActionsDialog.toggleLoading());
			dispatch(ActionsDialog.closeDialog());
			dispatch(showMessage({ message: 'Job Updated' }));
			dispatch(getJobs());
		})
		.catch(err => {
			dispatch(ActionsDialog.toggleLoading());
			dispatch(setJobError({ ...err.data, type: 'form' }));
		});
};

export const getParticipantJobs = () => dispatch => {
	dispatch(ActionsDialog.toggleLoading());
	const request = axios.get(`${API_BASE_URL}/api/jobs/participant`);
	return request
		.then(res => {
			dispatch(ActionsDialog.toggleLoading());
			dispatch(setJobList(res.data));
		})
		.catch(err => {
			dispatch(ActionsDialog.toggleLoading());
			dispatch(setJobError({ ...err.data, type: 'modal' }));
		});
};

export const participantSubmitJob = (id, cluster) => dispatch => {
	dispatch(ActionsDialog.toggleLoading());
	dispatch(showMessage({ message: 'Submitting Job' }));
	const request = axios.post(`${API_BASE_URL}/api/jobs/participant/submit`, { id, cluster });
	return request
		.then(() => {
			dispatch(ActionsDialog.toggleLoading());
			dispatch(showMessage({ message: 'Job Submitted' }));
		})
		.catch(err => {
			dispatch(ActionsDialog.toggleLoading());
			dispatch(setJobError({ ...err.data, type: 'modal' }));
		});
};

export const participantCancelJob = (job, cluster) => dispatch => {
	dispatch(ActionsDialog.toggleLoading());
	const request = axios.post(`${API_BASE_URL}/api/jobs/participant/cancel`, { job, cluster });
	return request
		.then(() => {
			dispatch(ActionsDialog.toggleLoading());
			dispatch(showMessage({ message: 'Job Canceled' }));
		})
		.catch(err => {
			dispatch(ActionsDialog.toggleLoading());
			dispatch(setJobError({ ...err.data, type: 'modal' }));
		});
};

export const deleteJob = id => dispatch => {
	dispatch(ActionsDialog.toggleLoading());
	const request = axios.delete(`${API_BASE_URL}/api/jobs/${id}`);
	return request
		.then(() => {
			dispatch(ActionsDialog.toggleLoading());
			dispatch(showMessage({ message: 'Job Deleted' }));
			dispatch(getJobs());
		})
		.catch(err => {
			dispatch(ActionsDialog.toggleLoading());
			dispatch(setJobError({ ...err.data, type: 'modal' }));
		});
};
